import React, { useState, useEffect, useCallback } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(targetDate) - new Date();
    
    if (difference > 0) {
      return {
        giorni: Math.floor(difference / (1000 * 60 * 60 * 24)),
        ore: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minuti: Math.floor((difference / 1000 / 60) % 60),
        secondi: Math.floor((difference / 1000) % 60)
      };
    }
    
    return null;
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      
      if (!newTimeLeft) {
        // Reset to 7 days when countdown ends (loop)
        const newTarget = new Date();
        newTarget.setDate(newTarget.getDate() + 7);
        setTimeLeft(calculateTimeLeft());
      } else {
        setTimeLeft(newTimeLeft);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  if (!timeLeft) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4 md:gap-8 max-w-full overflow-hidden">
      {Object.entries(timeLeft).map(([unit, value]) => (
        <div key={unit} className="flex flex-col items-center flex-shrink-0">
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6 w-16 sm:w-20 md:w-24 shadow-2xl">
            <div className="text-xl sm:text-3xl md:text-5xl font-black text-white text-center">
              {String(value).padStart(2, '0')}
            </div>
          </div>
          <div className="mt-2 sm:mt-3 text-[10px] sm:text-xs md:text-sm font-bold text-gray-400 uppercase tracking-wider">
            {unit}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
